// Alles rund ums Verarbeiten einer einzelnen WebSocket-Nachricht - Entpacken, Parsen, Status-Mapping,
// Anwenden auf ein Match-Objekt. Kein Vue-Bezug (bekommt die zu aktualisierende matches-Liste übergeben).

// football-data/api-sports-typische Kurzstatus-Codes -> unsere 4 Zustände
export function statusAusShortS(shortS, completedFlag) {
  if (completedFlag || ['FT', 'AET', 'PEN'].includes(shortS)) return 'beendet'
  if (shortS === 'NS') return 'bald' // Live-Tracking aktiv, aber noch nicht angepfiffen -> Countdown zeigen
  if (['PST', 'CANC', 'ABD', 'TBD'].includes(shortS) || !shortS) return 'geplant'
  return 'live' // 1H, HT, 2H, ET, BT, P, SUSP, INT, LIVE, ...
}

// Nutzt Index 0/1 statt Namensabgleich - passt zu allen bisher gesehenen WS-Beispielen
// (im Gegensatz zur REST-Variante ausScoreListe(), die per Name abgleicht).
//
// Zwei beobachtete Formate für .scores, je nach Match/Liga-Quelle:
//  - direkt ein Array: [{name, score}, {name, score}]
//  - ein Objekt mit verschachteltem Array: {hasScores: true, scores: [{name, score}, ...]}
// Robust gegen beide, statt nur das erste zu unterstützen.
export function ergebnisAusOddsMatchScores(oddsMatchScores) {
  const scoresRoh = oddsMatchScores.scores
  const scores = Array.isArray(scoresRoh)
    ? scoresRoh
    : (scoresRoh && Array.isArray(scoresRoh.scores)) ? scoresRoh.scores : null

  if (!scores || scores.length !== 2) return null

  const heim = scores[0].score
  const auswaerts = scores[1].score
  if (!heim || !auswaerts) return null
  const h = Number(heim)
  const a = Number(auswaerts)
  return { heimtore: Number.isNaN(h) ? null : h, austore: Number.isNaN(a) ? null : a }
}

// Nachricht ist ein Objekt mit mehreren Sammlungen (rankings, matches, tipps-live, ...) -
// wendeWsUpdateAn greift selbst auf .scores zu.
export function parseWsNachricht(raw) {
  return JSON.parse(raw)
}

// Server schickt Gzip-komprimierte Daten - entweder als Binär-Frame oder als Text-Frame,
// der selbst einen Base64-String enthält. Hier robust alle 3 Fälle abdecken:
// 1. Klartext-JSON (falls der Server das doch mal unkomprimiert schickt)
// 2. Text-Frame mit Base64-kodiertem Gzip
// 3. Echter Binär-Frame (ArrayBuffer/Blob) mit Gzip-Bytes
async function gunzipBytes(bytes) {
  const stream = new Blob([bytes]).stream().pipeThrough(new DecompressionStream('gzip'))
  return await new Response(stream).text()
}

export async function entpackeNachricht(data) {
  if (typeof data === 'string') {
    const getrimmt = data.trim()
    if (getrimmt.startsWith('{') || getrimmt.startsWith('[')) {
      return data // schon reines JSON, nichts zu tun
    }
    // Base64-String -> Bytes -> entpacken
    const binaryString = atob(getrimmt)
    const bytes = new Uint8Array(binaryString.length)
    for (let i = 0; i < binaryString.length; i++) bytes[i] = binaryString.charCodeAt(i)
    return await gunzipBytes(bytes)
  }
  // Binär-Frame (ArrayBuffer oder Blob)
  const buffer = data instanceof Blob ? await data.arrayBuffer() : data
  return await gunzipBytes(new Uint8Array(buffer))
}

// Wendet eine geparste WS-Nachricht auf die (reaktive) matches-Liste an - mutiert bestehende
// Match-Objekte direkt, damit Vue die Änderung reaktiv aufgreift.
export function wendeWsUpdateAn(eintrag, matches) {
  const scoreListe = eintrag?.scores
  if (!scoreListe) return

  scoreListe.forEach(score => {
    const oms = score.oddsMatchScores
    const match = matches.find(m => m.id === Number(oms.idDB))
    if (!match) return

    const ergebnis = ergebnisAusOddsMatchScores(oms)
    match.heimtore = ergebnis?.heimtore ?? null
    match.austore = ergebnis?.austore ?? null
    match.status = statusAusShortS(oms.status?.shortS, oms.completed)
    match.minute = oms.status?.elapsed ?? null
    match.spielUhrKurz = oms.status?.shortS ?? null // z.B. 'HT', '1H', '2H' - für Halbzeit-Anzeige
    match.spielUhrExtra = oms.status?.extra ?? null // Nachspielzeit in Minuten, z.B. 45+6'
    if (Array.isArray(oms.events)) match.events = oms.events
    if (Array.isArray(oms.lineups) && oms.lineups.length === 2) match.lineups = oms.lineups
  })
}